import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Download, X } from "lucide-react";
import { InstallButton } from "./InstallButton";

const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

// Slides up once per few days on first visits so installing the app is one tap.
export const InstallBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (standalone() || Date.now() - Number(localStorage.getItem("install_dismissed") || 0) < 3 * 86400000) return undefined;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);
  const close = () => { localStorage.setItem("install_dismissed", String(Date.now())); setShow(false); };
  return (
    <AnimatePresence>
      {show && <motion.div initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }} transition={{ type: "spring", damping: 24, stiffness: 260 }}
        className="fixed z-50 inset-x-3 bottom-[5.5rem] lg:bottom-6 lg:left-auto lg:right-6 lg:w-96 glass !bg-[var(--card)] p-4 shadow-2xl shadow-black/60" data-testid="install-banner">
        <button onClick={close} className="absolute top-3 right-3 text-slate-500" aria-label="Close" data-testid="install-banner-close"><X className="w-4 h-4" /></button>
        <div className="flex items-center gap-3 mb-3 pr-6"><img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl" />
          <div><div className="font-head font-extrabold uppercase text-lg leading-none flex items-center gap-1.5"><Download className="w-4 h-4 text-[var(--cyan)]" />Get the app</div>
            <p className="text-xs text-slate-400 mt-1">Full screen, on your home screen, with pick and price alerts. Free, no app store needed.</p></div></div>
        <InstallButton />
      </motion.div>}
    </AnimatePresence>
  );
};
